var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9435 25.0881V7.91211C18.9435 7.35982 18.4958 6.91211 17.9435 6.91211H13.8853C13.333 6.91211 12.8853 7.35982 12.8853 7.91211V25.0881M18.9435 25.0881L18.9419 14.7683C18.9418 14.2159 19.3896 13.7681 19.9419 13.7681H24C24.5523 13.7681 25 14.2158 25 14.7681V24.0881C25 24.6404 24.5523 25.0881 24 25.0881H18.9435ZM18.9435 25.0881H12.8853M12.8853 25.0881V20.0881C12.8853 19.5358 12.4376 19.0881 11.8853 19.0881H8C7.44771 19.0881 7 19.5358 7 20.0881V24.0881C7 24.6404 7.44771 25.0881 8 25.0881H12.8853Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 10.8333,
    x2: 27,
    y2: 10.8333,
    stroke: "current",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.b1a78825805b0d7be5a3264fd4abe77c.svg";
export { ForwardRef as ReactComponent };